// extracted by mini-css-extract-plugin
module.exports = {"Sorting_Icon":"SortingIcon_Sorting_Icon__1qwIL","Sorting_Icon--asc":"SortingIcon_Sorting_Icon--asc__BKPL0","Sorting_Icon--desc":"SortingIcon_Sorting_Icon--desc___pPjZ"};